import { ADDING_PERK } from "constants/perks";
import { Form, Formik } from "formik";
import { useToast } from "hooks/useToast";
import { addPerk } from "../../../apis/perksApis";
import FilledCaretLeft from "../../../static/images/FilledLeftCaret.svg";
import PerkTypeRedemption from "./perkTypeRedemption";
import { Button } from "components/DesignSystem/Button/Button";

const RedemptionInformation = ({ goBack, setCurrentState, perkData }) => {
  const { perkType } = perkData;
  const { alertToast, info: infoToast } = useToast();

  const showData = async (values) => {
    try {
      let data = { ...perkData, ...values };
      infoToast({ message: ADDING_PERK });
      const res = await addPerk({ data });
      if (res.status === 200) setCurrentState(3);
    } catch (e) {
      alertToast({ message: e?.response?.data?.error?.message });
    }
  };

  return (
    <>
      <span className="perkRightContainerHeader">Redemption Information</span>
      <Formik
        initialValues={{
          couponCode: "",
          redemptionUrl: "",
          utmLink: "",
          referralEmail: "",
          introEmail: "",
        }}
        onSubmit={showData}
      >
        <Form className="w-100 newPerkForm">
          <PerkTypeRedemption perkType={perkType} />
          <div className="d-flex justify-content-between w-100 perkBtns">
            <Button onClick={goBack} type="button">
              Cancel
            </Button>
            <span className="t-flex t-items-center">
              <Button customType="ghost">
                <img
                  src={FilledCaretLeft}
                  alt="FilledCaretLeft"
                  onClick={() => setCurrentState(1)}
                />
              </Button>
              &nbsp;
              <Button type="submit" customType="primary">
                Submit
              </Button>
            </span>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default RedemptionInformation;
